import Flickity from 'flickity';

let options = {
	//freeScroll: true,
	groupCells: true,
	prevNextButtons: true,
	pageDots: false,
	cellAlign: 'left',
	contain: true,
	percentPosition: true,
	//wrapAround: true
};

function initFlickitys(sel = '', options = {}) {
	if (!sel) return;
	let els = document.querySelectorAll(sel);
	if (!els.length) return;
	for (let el of els) {
		new Flickity(el, options);
	}
}

initFlickitys('.carousel-cards', options);
initFlickitys('.timeline-carousel', options);
